module.exports = __webpack_public_path__ + "static/freshman-3-4b97e3b18fb87eec62cc3c20d78be524.jpg";